var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigateBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.585637 4.43896C0.16817 4.84146 0.156034 5.50617 0.558531 5.92364C0.961028 6.3411 1.62574 6.35324 2.04321 5.95074L5.35967 2.75321L8.5572 6.06967C8.9597 6.48714 9.62441 6.49927 10.0419 6.09678C10.4593 5.69428 10.4715 5.02957 10.069 4.6121L6.14266 0.539749C5.74017 0.122282 5.07545 0.110146 4.65799 0.512643L0.585637 4.43896Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateBottom);
export default __webpack_public_path__ + "static/media/navigate_bottom.0ec18aaec84b7bf1c59bbd4ec58991a6.svg";
export { ForwardRef as ReactComponent };